// Pure helpers for the Duty Assistant admin screens — extracted so they can be unit-tested
// with the bare jest that ships with react-scripts (no @testing-library needed).

// Shape the Knowledge Base form values into the API payload (camelCase; the w-api parser
// converts to snake_case). See w-api Admin_Management contract.
export const buildKbPayload = values => ({
  title: values.title,
  topic: values.topic,
  service: values.service || 'duty',
  trigger: values.trigger || '',
  content: values.content,
  isAlwaysOn: !!values.isAlwaysOn,
  priority: values.priority || 0,
  isActive: values.isActive !== undefined ? values.isActive : true
})

// A body type with no/zero service price is a paywall misconfiguration (Req 2.3).
export const isUnsetPrice = record =>
  !record || !record.servicePrice || Number(record.servicePrice) <= 0

// Display a body type's price, or an em dash when unset.
export const formatPrice = record => {
  if (isUnsetPrice(record)) return '—'
  return `${record.servicePriceCurrency || 'GHS'} ${Number(
    record.servicePrice
  ).toFixed(2)}`
}

// Validate a price entry before saving (non-negative number).
export const isValidPrice = value =>
  value !== null && value !== undefined && !Number.isNaN(Number(value)) && Number(value) >= 0
